var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLifetrackDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dhl_icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33,28h5.1333L24,42,9.8667,28h9.5669l2.709,4.5146A.9994.9994,0,0,0,23,33c.0264,0,.0532-.001.08-.0034a1,1,0,0,0,.8486-.625L29,19.6924l3.0713,7.6792A1.0011,1.0011,0,0,0,33,28ZM20.8574,26.4854,22.82,29.7568l5.251-13.1284a1,1,0,0,1,1.8574,0L33.6772,26h6.3094A9.9942,9.9942,0,0,0,24.929,12.929L24,13.8579h0l-.9289-.9289A9.9942,9.9942,0,0,0,8.0134,26H20A1,1,0,0,1,20.8574,26.4854Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifetrackDark);
export default __webpack_public_path__ + "static/media/LifetrackDark.4fcae4fc09ec2dcb0559ac32bfcbc600.svg";
export { ForwardRef as ReactComponent };